module.exports = ":host .proof {\n  position: relative; }\n\n:host .photographers-choice {\n  position: absolute;\n  top: 5px;\n  right: 5px; }\n\n:host .awesome-enlargement {\n  position: absolute;\n  top: 5px;\n  left: 5px; }\n\n:host .resolution-warning {\n  position: absolute;\n  bottom: 5px;\n  left: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/proof/proof.component.scss
// module id = ./src/app/shared/proof/proof.component.scss
// module chunks = main